import LPResultsPage from "./LPResultsPage";

export default function LPDigitalMarketingResultsPage() {
  return <LPResultsPage lpSlug="digitalmarketing" lpName="Digital Marketing" />;
}
